import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind'
import { withRouter, Redirect } from 'react-router-dom';
import RegisterHeader from './../components/Register/Header';
import Alert from './../components/Errors/Alert'
// import _ from 'lodash'

class RegisterPaymentInfoPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            companyName: props.companyName || "",
            cui: props.cui || "",
            accountNumber: props.accountNumber || "",

            contactName: props.contactName || "",
            contactPhone: props.contactPhone || "",
            contactEmail: props.contactEmail || "",
        };
        autobind(this)
    }

    componentDidMount() {
        this.props.resetRegistrationStep(4)
        document.title = "Register Payment Info"

    }

    componentWillReceiveProps(props) {
        const { error, user, completed, step1 } = props
        if (!user && completed) {
            this.props.login(step1.email, step1.password)
        } else {
            this.setState({ error })
        }
    }

    onCompanyNameChange(event) {
        this.setState({ companyName: event.target.value });
    }

    onCuiChange(event) {
        this.setState({ cui: event.target.value });
    }

    onAccountNumberChange(event) {
        this.setState({ accountNumber: event.target.value });
    }

    onContactNameChange(event) {
        this.setState({ contactName: event.target.value });
    }

    onContactPhoneChange(event) {
        this.setState({ contactPhone: event.target.value });
    }

    onContactEmailChange(event) {
        this.setState({ contactEmail: event.target.value });
    }


    onNextButtonClick() {

        const { step1, step2, step3 } = this.props
            , { companyName, cui, accountNumber, contactName, contactPhone, contactEmail } = this.state
            , step4 = { companyName, cui, accountNumber, contactName, contactPhone, contactEmail }
        this.props.registerFlowStep4(
            step1, step2, step3, step4
        )
    }

    render() {

        const { companyName, cui, accountNumber, contactName, contactPhone, contactEmail, error } = this.state
            , { step1, step2, step3, user } = this.props

        if (user) {
            return <Redirect to="/stories" />
        }

        if (!step1) {
            return <Redirect to="/register" />
        }

        if (!step2) {
            return <Redirect to="/register/contact-info" />
        }

        if (!step3) {
            return <Redirect to="/register/payment-plans" />
        }

        const payedSubscription = step3.subscriptions.reduce((acc, s) => s.price > 0 || acc, false)
        let filledPaymentInfoData = false
        if (companyName.length && cui.length && accountNumber.length && contactName.length && contactEmail.length && contactPhone.length) filledPaymentInfoData = true
        const nextEnabled = (payedSubscription && filledPaymentInfoData) || (!payedSubscription)

        return (
            <div>
                <RegisterHeader />
                <div className="main-content main-content--register container">
                    <div className="row">
                        <div className="col">
                            <div className="panel panel--rounded panel-default mb-5">
                                <div className="panel-heading panel-heading--lg panel-heading-divider">
                                    Payment info
                                </div>
                                <div className="panel-body">
                                    {error ? (<div className="form-group row d-flex justify-content-center">
                                        <div className="col-sm-6">
                                            <Alert message={error} />
                                        </div>
                                    </div>) : null}
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2">Name</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="text" placeholder="" className="form-control" value={companyName} onChange={this.onCompanyNameChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2">Registration Number/SSN</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="text" placeholder="" className="form-control" value={cui} onChange={this.onCuiChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2">Bank Account</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="text" placeholder="" className="form-control" value={accountNumber} onChange={this.onAccountNumberChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel panel--rounded panel-default mb-5">
                                <div className="panel-heading panel-heading--lg panel-heading-divider">
                                    Contact person
                            </div>
                                <div className="panel-body">
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2" >Name</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="text" placeholder="" className="form-control" value={contactName} onChange={this.onContactNameChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2" >Phone</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="text" placeholder="" className="form-control" value={contactPhone} onChange={this.onContactPhoneChange} />
                                        </div>
                                    </div>
                                    <div className="form-group row align-items-end">
                                        <label className="col-sm-3 mb-2 col-form-label offset-sm-2">Email</label>
                                        <div className="col-sm-5">
                                            <p className="mb-0 text-right">*</p>
                                            <input type="email" placeholder="" className="form-control" value={contactEmail} onChange={this.onContactEmailChange} required/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center">
                                <button className="btn btn-rounded btn-space btn-transparent btn-lg-lateral-space mr-3" onClick={() => this.props.history.goBack()}>Back</button>                                
                                <button className="btn btn-rounded btn-space btn-primary btn-lg-lateral-space" disabled={nextEnabled ? '' : 'disabled'} onClick={this.onNextButtonClick}>Next</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { registerFlow: { error, companyName, cui, accountNumber, contactName, contactPhone, contactEmail, step1, step2, step3, completed }, auth: { user } } = state
        return { error, companyName, cui, accountNumber, contactName, contactPhone, contactEmail, step1, step2, step3, completed, user }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps);
    }
)(withRouter(RegisterPaymentInfoPage))



// WEBPACK FOOTER //
// ./src/containers/RegisterPaymentInfo.js